import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { ValidateZipCodeResponse } from '../@types/ValidateZipCode'

type Store = {
  zipCodeResult: ValidateZipCodeResponse | null
  setZipCodeResult: (value: ValidateZipCodeResponse) => void
}

export const useZipCodeStore = create<Store>()(
  devtools(
    (set) => ({
      zipCodeResult: null,
      setZipCodeResult: (zipCodeResult) => set({ zipCodeResult }),
    }),
    { name: 'ZipCodeStore' },
  ),
)
